// Angular imports
import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

// Service imports
import { AuthService } from '../_services/auth.service';

@Injectable({ providedIn: 'root' })
export class AlreadyLoggedInGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  canActivate(): boolean {
    if (this.authService.isLoggedIn) {
      this.router.navigate(['/home']);
      return false;
    }
    return true;
  }
}
